
export const textes = {
    fr: {
        appname: "YCONNEKT WEB",
        appdesc: "Plateforme de fourniture d'accès à internet.",
        login: "Connexion",
        logindesc: "Vous ne possedez pas encore un compte?",
        signin: "Créer son compte",
        resetpass: "Réinitialiser mot de passe",
        forgotpass: "Mot de passe oublié",
        signindesc: "Avez vous déjà un compte?",
        confirmaccount: "Confirmer votre compte",
        confirmaccountdesc: "Veillez saisir le code de confirmation reçu par email.",
        signinlogininput: "Login ou adresse email...",
        signinpassinput: "Mot de passe...",
        signinconfirmpassinput: "Confirmer mot de passe",
        norulesfound: "Compte erroné. aucun privilèges associé!",
        noprofilsfound: "Compte erroné. aucun profil associé!",
        desabledaccount: "Votre compte a été bloqué!",
        wrongpassword: "Mot de passe inccorect!",
        invalidlogin: "Ce login ou adresse email n'existe pas!",
        existlogin: "Cette adresse email est déjà utilisé par un autre utilisateur!",
        sessionexpmsg: "Votre session a expirée...",
        requestfail: "Echec de la requête. Veuillez reessayer plutard!",
        serviceunavaillable: "Service indisponible. Veuillez reessayer plutard!",
        oparationfail: "Echec de l'opération.",
        oparationsuccess: "Opération réussi.",
        cantdeleteusedelement: "Impossible de supprimer une donnée utilisée.",
        nodatafound: "Aucune donnée trouvée.",
        updatelabel: "Modifier",
        updatedesclabel: "Etes-vous sur de vouloir modifier cet élément?",
        deletelabel: "Supprimer",
        deletedesclabel: "Etes-vous sur de vouloir supprimer cet élément?",
        addlabel: "Ajouter",
        adddesclabel: "Etes-vous sur de vouloir ajouter cet élément?",
        conditionslabel: "CONDITIONS D'UTILISATION",

        addeddatelabel: "Date d'ajout",
        actionlabel: "Actions",
        libellelabel: "Libelle",
        enterlibellelabel: "Entrez le libelle",
        namelabel: "Nom",
        enternamelabel: "Entrez le nom",
        descriptionlabel: "Description",
        enterdescriptionlabel: "Entrez la description",
        abreviationlabel: "Abreviation",
        enterabreviationlabel: "Entrez l'abreviation",
        durelabel: "Durée",
        datedeblabel: "Date début",
        enterdatedeblabel: "Entrez la date de début",
        heuredeblabel: "Heure de début",
        enterheuredeblabel: "Entrez l'heure de début",
        datefinlabel: "Date fin",
        enterdatefinlabel: "Entrez la date de fin",
        datelimitlabel: "Date limite",
        enterdatelimitlabel: "Entrez la date limite",
        statelabel: "Etat",
        statutlabel: "Statut",
        finishlabel: "Achevé",
        paiedlabel: "Payé",
        tauxlabel: "Taux",
        montantlabel: "Montant",
        basesalarylabel: "Salaire base",
        numberagentlabel: "Nombre d'agent",
        agentlabel: "Agent (s)",
        numberpriseservicelabel: "Nombre de prises de service",
        imagelabel: "Image",
        selectimagelabel: "Sélectionnez l'image",
        validateaddlabel: "Valider l'ajout",
        validateeditlabel: "Valider la mise à jour",
        infolabel: "Informations",
        quantitelabel: "Quantité",
        quantiterestelabel: "Quantité restante",
        enterquantitelabel: "Entrez la quantité",
        nationalitylabel: "Nationalité",
        selectnationalitylabel: "Selectionnez la nationalité",
        matriculelabel: "Matricule",
        entermatriculelabel: "Entrez le matricule",
        numpilabel: "Numéro pièce d'identité",
        enternumpilabel: "Entrez le numéro de la pièce d'identité",
        fistnamelabel: "Nom",
        enterfistnamelabel: "Entrez le nom",
        lastnamelabel: "Prénom",
        enterlastnamelabel: "Entrez le prénom",
        addresslabel: "Adresse",
        enteraddresslabel: "Entrez l'adresse",
        emaillabel: "Adresse Email",
        enteremaillabel: "Entrez l'adresse email",
        phonelabel: "Numéro de téléphone",
        enterphonelabel: "Entrez le numéro de téléphone",
        datenaislabel: "Date de naissance",
        enterdaenaislabel: "Entrez la date de naissance",
        nbchildlabel: "Nombre d'enfants",
        enternbchildlabel: "Entrez le nombre d'enfant",
        familysituationlabel: "Situation familiale",
        selectfamilysituationlabel: "Selectionnez la situation familiale",
        sexelabel: "Sexe",
        selectsexelabel: "Selectionnez le sexe",
        entervaluelabel: "Entrez une valeur",
        image1label: "Image 1",
        image2label: "Image 2",
        image3label: "Image 3",
        image4label: "Image 4",
        image5label: "Image 5",
        photolabel: "Photo",
        selectphotolabel: "Selectionnez la photo",
        selectlabel: "Sélectionnez...",


        // profils
        newprofillabel: "Nouveau profil",
        listprofillabel: "Liste des profils",
        profillabel: "Profil",
        noprofilfound: "Aucun profil trouvé.",
        viewprofillabel: "Consulter le profil",
        selectprofillabel: "Selectionnez le profil",
        // newprofillabel : "",



        // actions
        loginbtn: "Se Connecter",
        signinbtn: "S'inscrire",
        continueas: "Continuer en tant que...",
        cancel: "Annuler",
        back: "Retour",
        quit: "Quitter",
        validate: "Valider",
        confirm: "Confirmer",
        edit: "Modifier",
        delete: "Delete",
        affect: "Affecter",
        reset: "Réinitialiser",

        // menu
        dashbordlabel: "Tableau de bord",
        incrementslabel: "Incréments",
        domainslabel: "Domaines",
        customerslabel: "Clients",
        licenceslabel: "Licences",
        ruleslabel: "Privilèges",
        workspaceslabel: "Espaces de travail",
        profilslabel: "Profils",
        accountslabel: "Comptes",
        userslabel: "Utilisateurs",
        connexionslabel: "Connexion",
        activitieslabel: "Activités",

        //***************************************** *//
        //              Fonctionnalités             //
        //*************************************** *//

    
        // typeabonnements
        newtypeabonnementlabel: "Nouveau type d'abonnement",
        listtypeabonnementlabel: "Liste des types d'abonnement",
        typeabonnementlabel: "Type d'abonnement",
        typeabonnementslabel: "Types d'abonnement",
        notypeabonnementfound: "Aucun type d'abonnement trouvé.",
        viewtypeabonnementlabel: "Consulter le type d'abonnement",
        typeabonnementinfoslabel: "Informations du type d'abonnement",
        typeabonnementaddedlabel: "Type d'abonnement ajouté avec succès.",
        deletetypeabonnementlabel: "Supprimer?",
        deletetypeabonnementlabeldesc: "Etes-vous sûr de vouloir supprimer ce type d'abonnement?",
        edittypeabonnementlabel: "Modifier?",
        edittypeabonnementlabeldesc: "Etes-vous sûr de vouloir modifier ce type d'abonnement?",
        cantdeleteusetypeabonnementlabel: "Impossible de suppimer un type d'abonnement utilisé.",
        typeabonnementdeletedlabel: "Type d'abonnement supprimé avec succès.",
        typeabonnementupdatedlabel: "Type d'abonnement modifié avec succès.",
        selecttypeabonnementlabel: "Selectionnez le type d'abonnement",
        // newtypeabonnementlabel : "",

        
        // abonnements
        newabonnementlabel: "Nouvel abonnement",
        listabonnementlabel: "Liste des abonnements",
        historiqueabonnementlabel: "Historique des abonnements",
        abonnementlabel: "Abonnement",
        abonnementslabel: "Abonnements",
        noabonnementfound: "Aucun abonnement trouvé.",
        viewabonnementlabel: "Consulter l'abonnement",
        abonnementaddedlabel: "Abonnement ajouté avec succès.",
        abonnementinfoslabel: "Informations de l'abonnement",
        deleteabonnementlabel: "Supprimer?",
        deleteabonnementlabeldesc: "Etes-vous sûr de vouloir supprimer cet abonnement?",
        editabonnementlabel: "Modifier?",
        editabonnementlabeldesc: "Etes-vous sûr de vouloir modifier cet abonnement?",
        cantdeleteuseabonnementlabel: "Impossible de suppimer un abonnement utilisé.",
        abonnementdeletedlabel: "Abonnement supprimé avec succès.",
        abonnementupdatedlabel: "Abonnement modifié avec succès.",
        // newabonnementlabel : "",
        
        // sites
        newsitelabel: "Nouveau site",
        listsitelabel: "Liste des sites",
        historiquesitelabel: "Historique des sites",
        sitelabel: "Site",
        siteslabel: "Sites",
        nositefound: "Aucun site trouvé.",
        viewsitelabel: "Consulter le site",
        siteaddedlabel: "Site ajouté avec succès.",
        siteinfoslabel: "Informations du site",
        deletesitelabel: "Supprimer?",
        deletesitelabeldesc: "Etes-vous sûr de vouloir supprimer ce site?",
        editsitelabel: "Modifier?",
        editsitelabeldesc: "Etes-vous sûr de vouloir modifier ce site?",
        cantdeleteusesitelabel: "Impossible de suppimer un site utilisé.",
        sitedeletedlabel: "Site supprimé avec succès.",
        siteupdatedlabel: "Site modifié avec succès.",
        // newsitelabel : "",
        
        // hotspots
        newhotspotlabel: "Nouveau hotspot",
        listhotspotlabel: "Liste des hotspots",
        historiquehotspotlabel: "Historique des hotspots",
        hotspotlabel: "Hotspot",
        hotspotslabel: "Hotspots",
        nohotspotfound: "Aucun hotspot trouvé.",
        viewhotspotlabel: "Consulter le hotspot",
        hotspotaddedlabel: "Hotspot ajouté avec succès.",
        hotspotinfoslabel: "Informations du hotspot",
        deletehotspotlabel: "Supprimer?",
        deletehotspotlabeldesc: "Etes-vous sûr de vouloir supprimer ce hotspot?",
        edithotspotlabel: "Modifier?",
        edithotspotlabeldesc: "Etes-vous sûr de vouloir modifier ce hotspot?",
        cantdeleteusehotspotlabel: "Impossible de suppimer un hotspot utilisé.",
        hotspotdeletedlabel: "Hotspot supprimé avec succès.",
        hotspotupdatedlabel: "Hotspot modifié avec succès.",
        // newhotspotlabel : "",
    
        // typeforfaits
        newtypeforfaitlabel: "Nouveau type de forfait",
        listtypeforfaitlabel: "Liste des types de forfait",
        typeforfaitlabel: "Type de forfait",
        typeforfaitslabel: "Types de forfait",
        notypeforfaitfound: "Aucun type de forfait trouvé.",
        viewtypeforfaitlabel: "Consulter le type de forfait",
        typeforfaitinfoslabel: "Informations du type de forfait",
        typeforfaitaddedlabel: "Type de forfait ajouté avec succès.",
        deletetypeforfaitlabel: "Supprimer?",
        deletetypeforfaitlabeldesc: "Etes-vous sûr de vouloir supprimer ce type de forfait?",
        edittypeforfaitlabel: "Modifier?",
        edittypeforfaitlabeldesc: "Etes-vous sûr de vouloir modifier ce type de forfait?",
        cantdeleteusetypeforfaitlabel: "Impossible de suppimer un type de forfait utilisé.",
        typeforfaitdeletedlabel: "Type de forfait supprimé avec succès.",
        typeforfaitupdatedlabel: "Type de forfait modifié avec succès.",
        selecttypeforfaitlabel: "Selectionnez le type de forfait",
        // newtypeforfaitlabel : "",
    
        // wifiaccounts
        newwifiaccountlabel: "Nouveau compte wifi",
        listwifiaccountlabel: "Liste des comptes wifi",
        wifiaccountlabel: "Compte wifi",
        wifiaccountslabel: "Comptes wifi",
        nowifiaccountfound: "Aucun compte wifi trouvé.",
        viewwifiaccountlabel: "Consulter le compte wifi",
        wifiaccountinfoslabel: "Informations du compte wifi",
        wifiaccountaddedlabel: "Compte wifi ajouté avec succès.",
        deletewifiaccountlabel: "Supprimer?",
        deletewifiaccountlabeldesc: "Etes-vous sûr de vouloir supprimer ce compte wifi?",
        editwifiaccountlabel: "Modifier?",
        editwifiaccountlabeldesc: "Etes-vous sûr de vouloir modifier ce compte wifi?",
        cantdeleteusewifiaccountlabel: "Impossible de suppimer un compte wifi utilisé.",
        wifiaccountdeletedlabel: "Compte wifi supprimé avec succès.",
        wifiaccountupdatedlabel: "Compte wifi modifié avec succès.",
        selectwifiaccountlabel: "Selectionnez le compte wifi",
        // newwifiaccountlabel : "",

        
        // forfaits
        newforfaitlabel: "Nouveau forfait",
        listforfaitlabel: "Liste des forfaits",
        historiqueforfaitlabel: "Historique des forfaits",
        forfaitlabel: "Forfait",
        forfaitslabel: "Forfaits",
        noforfaitfound: "Aucun forfait trouvé.",
        viewforfaitlabel: "Consulter le forfait",
        forfaitaddedlabel: "Forfait ajouté avec succès.",
        forfaitinfoslabel: "Informations de le forfait",
        deleteforfaitlabel: "Supprimer?",
        deleteforfaitlabeldesc: "Etes-vous sûr de vouloir supprimer ce forfait?",
        editforfaitlabel: "Modifier?",
        editforfaitlabeldesc: "Etes-vous sûr de vouloir modifier ce forfait?",
        cantdeleteuseforfaitlabel: "Impossible de suppimer un forfait utilisé.",
        forfaitdeletedlabel: "Forfait supprimé avec succès.",
        forfaitupdatedlabel: "Forfait modifié avec succès.",
        // newforfaitlabel : "",

        
        // revendeurs
        newrevendeurlabel: "Nouveau revendeur",
        listrevendeurlabel: "Liste des revendeurs",
        historiquerevendeurlabel: "Historique des revendeurs",
        revendeurlabel: "Revendeur",
        revendeurslabel: "Revendeurs",
        norevendeurfound: "Aucun revendeur trouvé.",
        viewrevendeurlabel: "Consulter le revendeur",
        revendeuraddedlabel: "Revendeur ajouté avec succès.",
        revendeurinfoslabel: "Informations de le revendeur",
        deleterevendeurlabel: "Supprimer?",
        deleterevendeurlabeldesc: "Etes-vous sûr de vouloir supprimer ce revendeur?",
        editrevendeurlabel: "Modifier?",
        editrevendeurlabeldesc: "Etes-vous sûr de vouloir modifier ce revendeur?",
        cantdeleteuserevendeurlabel: "Impossible de suppimer un revendeur utilisé.",
        revendeurdeletedlabel: "Revendeur supprimé avec succès.",
        revendeurupdatedlabel: "Revendeur modifié avec succès.",
        // newrevendeurlabel : "",
    
        // souscriptions
        newsouscriptionlabel: "Nouvelle souscription",
        listsouscriptionlabel: "Liste des souscriptions",
        souscriptionlabel: "Souscription",
        souscriptionslabel: "Souscriptions",
        nosouscriptionfound: "Aucune souscription trouvée.",
        viewsouscriptionlabel: "Consulter la souscription",
        souscriptioninfoslabel: "Informations de la souscription",
        souscriptionaddedlabel: "Souscription ajoutée avec succès.",
        deletesouscriptionlabel: "Supprimer?",
        deletesouscriptionlabeldesc: "Etes-vous sûr de vouloir supprimer cette souscription?",
        editsouscriptionlabel: "Modifier?",
        editsouscriptionlabeldesc: "Etes-vous sûr de vouloir modifier cette souscription?",
        cantdeleteusesouscriptionlabel: "Impossible de suppimer une souscription utilisé.",
        souscriptiondeletedlabel: "Souscription supprimée avec succès.",
        souscriptionupdatedlabel: "Souscription modifiée avec succès.",
        selectsouscriptionlabel: "Selectionnez la souscription",
        // newsouscriptionlabel : "",
    
        // transactions
        newtransactionlabel: "Nouvelle transaction",
        listtransactionlabel: "Liste des transactions",
        transactionlabel: "Transaction",
        transactionslabel: "Transactions",
        notransactionfound: "Aucune transaction trouvée.",
        viewtransactionlabel: "Consulter la transaction",
        transactioninfoslabel: "Informations de la transaction",
        transactionaddedlabel: "Transaction ajoutée avec succès.",
        deletetransactionlabel: "Supprimer?",
        deletetransactionlabeldesc: "Etes-vous sûr de vouloir supprimer cette transaction?",
        edittransactionlabel: "Modifier?",
        edittransactionlabeldesc: "Etes-vous sûr de vouloir modifier cette transaction?",
        cantdeleteusetransactionlabel: "Impossible de suppimer une transaction utilisé.",
        transactiondeletedlabel: "Transaction supprimée avec succès.",
        transactionupdatedlabel: "Transaction modifiée avec succès.",
        selecttransactionlabel: "Selectionnez la transaction",
        // newtransactionlabel : "",
    
        // publicites
        newpublicitelabel: "Nouvelle publicite",
        listpublicitelabel: "Liste des publicites",
        publicitelabel: "Publicite",
        publiciteslabel: "Publicites",
        nopublicitefound: "Aucune publicite trouvée.",
        viewpublicitelabel: "Consulter la publicite",
        publiciteinfoslabel: "Informations de la publicite",
        publiciteaddedlabel: "Publicite ajoutée avec succès.",
        deletepublicitelabel: "Supprimer?",
        deletepublicitelabeldesc: "Etes-vous sûr de vouloir supprimer cette publicite?",
        editpublicitelabel: "Modifier?",
        editpublicitelabeldesc: "Etes-vous sûr de vouloir modifier cette publicite?",
        cantdeleteusepublicitelabel: "Impossible de suppimer une publicite utilisé.",
        publicitedeletedlabel: "Publicite supprimée avec succès.",
        publiciteupdatedlabel: "Publicite modifiée avec succès.",
        selectpublicitelabel: "Selectionnez la publicite",
        // newpublicitelabel : "",
    
        // dmretratis
        newdmretratilabel: "Nouvelle demande de retrait",
        listdmretratilabel: "Liste des demandes de retrait",
        dmretratilabel: "Demande de retrait",
        dmretratislabel: "Demandes de retrait",
        nodmretratifound: "Aucune demande de retrait trouvée.",
        viewdmretratilabel: "Consulter la demande de retrait",
        dmretratiinfoslabel: "Informations de la demande de retrait",
        dmretratiaddedlabel: "Demande de retrait ajoutée avec succès.",
        deletedmretratilabel: "Supprimer?",
        deletedmretratilabeldesc: "Etes-vous sûr de vouloir supprimer cette demande de retrait?",
        editdmretratilabel: "Modifier?",
        editdmretratilabeldesc: "Etes-vous sûr de vouloir modifier cette demande de retrait?",
        cantdeleteusedmretratilabel: "Impossible de suppimer une demande de retrait utilisé.",
        dmretratideletedlabel: "Demande de retrait supprimée avec succès.",
        dmretratiupdatedlabel: "Demande de retrait modifiée avec succès.",
        selectdmretratilabel: "Selectionnez la demande de retrait",
        // newdmretratilabel : "",
        
        // comptevpns
        newcomptevpnlabel: "Nouveau compte VPN",
        listcomptevpnlabel: "Liste des comptes VPN",
        historiquecomptevpnlabel: "Historique des comptes VPN",
        comptevpnlabel: "Compte VPN",
        comptevpnslabel: "Comptes VPN",
        nocomptevpnfound: "Aucun compte VPN trouvé.",
        viewcomptevpnlabel: "Consulter le compte VPN",
        comptevpnaddedlabel: "Compte VPN ajouté avec succès.",
        comptevpninfoslabel: "Informations du compte VPN",
        deletecomptevpnlabel: "Supprimer?",
        deletecomptevpnlabeldesc: "Etes-vous sûr de vouloir supprimer ce compte VPN?",
        editcomptevpnlabel: "Modifier?",
        editcomptevpnlabeldesc: "Etes-vous sûr de vouloir modifier ce compte VPN?",
        cantdeleteusecomptevpnlabel: "Impossible de suppimer un compte VPN utilisé.",
        comptevpndeletedlabel: "Compte VPN supprimé avec succès.",
        comptevpnupdatedlabel: "Compte VPN modifié avec succès.",
        // newcomptevpnlabel : "",

        // home texte
        titre1home: "Bienvenue sur le réseau",
        homename: "YCONNEKT",
        soustitre1home: "Réseau panafricain qui mise sur des partenaires locaux pour déployer des points WIFI haut débit dans des zones stratégiques (carrefours, marchés, gares, campus, cité universitaire, etc...), là où la circulation humaine est maximale.",
        soustitre2home: "L'objectif est de fournir un internet abordable, rapide et sécurisé tout en permettant aux partenaires de générer des revenus via un système de revente intelligent, piloté depuis une plateforme en ligne.",
        starttexte: "Démarrer",
        slogant: "YCONNEKT est un réseau d'accès internet par wifi",
        titreaboutus: "A propos de nous",
        aboutdesc: "Chez YCONNEKT, chaque partenaire devient un acteur clé de l'inclusion numérique en fonction de sa localisation. Grace à des Packs d'équipement adaptés et une plateforme de gestion intelligente, ils transforment les zones à fort trafic en hubs internet rentables, tout en rendant le numérique accessible à tous.",
        aboutdesc2: "Devenez partenaire YCONNEKT et profiter d'un modèle économique Attractif :",
        // titre1home: "",
    },
    en: {},
}